module.exports = __webpack_public_path__ + "static/media/download.8ff0fafe.svg";